/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const MatchingConfigurationReason = {
    NoSpecificReason: 'NoSpecificReason',
    ReduceCandidateVolume: 'ReduceCandidateVolume',
    ImproveCandidateQuality: 'ImproveCandidateQuality'
};
export function instanceOfMatchingConfigurationReason(value) {
    for (const key in MatchingConfigurationReason) {
        if (Object.prototype.hasOwnProperty.call(MatchingConfigurationReason, key)) {
            if (MatchingConfigurationReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function MatchingConfigurationReasonFromJSON(json) {
    return MatchingConfigurationReasonFromJSONTyped(json, false);
}
export function MatchingConfigurationReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MatchingConfigurationReasonToJSON(value) {
    return value;
}
export function MatchingConfigurationReasonToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
